import React from 'react'
import { connect } from 'react-redux'
import styles from './ReportList.scss'
import appStyles from '../../App/appStyles.scss'
import { ReportCard } from '../ReportCard'
import { errorMessage, noReportsMessage } from '../Messages'
import { rrMessages } from '../../intlMessages'
import { CircleSpinner } from 'common/spinners'
import { ScrollTrigger } from 'common/ScrollTrigger'
import { Button } from 'common/Button'
import * as reportActions from 'lib/api/rideReports'
import { Msg, fm, commonActions } from 'lib/localization'
import Helmet from 'react-helmet'
import { injectIntl } from 'react-intl'

export class ReportList extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      loadOnScroll: false
    }
  }

  componentDidMount () {
    const { endpoint, loadReportsForIndex } = this.props
    // refresh topic on mount
    if (endpoint) {
      loadReportsForIndex(endpoint)
    }
  }

  loadNextPage = () => {
    const { endpoint, nextPage, loadReportsForIndex } = this.props
    if (!nextPage || nextPage === 0) { return } // redundant, we handle this in componentDidMount
    if (endpoint && nextPage !== -1) {
      loadReportsForIndex(endpoint, nextPage)
    }
  }

  loadOnScroll = () => {
    this.setState({ loadOnScroll: true })
    this.loadNextPage()
  }

  render () {
    const { loadOnScroll } = this.state
    const { title, reports, loading, error, currentUser, nextPage, children, weeklyWinnerIds, wheelsetWinnerIds, grandPrizeWinnerId, intl } = this.props

    let pageTitle = title
    // TODO this is messy but works, for now
    if (!pageTitle && reports && reports.size > 0) {
      pageTitle = fm(intl, rrMessages.reportsBy, { name: reports.first().user.name })
    }
    const spinner = <div className={styles.spinner}><CircleSpinner size={50} />
    </div>
    const getOverlay = (id) => {
      if (id === grandPrizeWinnerId) {
        return '/images/ride_reports_rollout/grand_winner.png'
      } else if (weeklyWinnerIds.indexOf(id) !== -1) {
        return '/images/ride_reports_rollout/weekly_winner.png'
      } else if (wheelsetWinnerIds.indexOf(id) !== -1) {
        return '/images/ride_reports_rollout/wheelset_winner.png'
      }
    }
    return (
      <div className={styles.ReportList}>
        <h1 className={appStyles.pageTitle}>{pageTitle}</h1>
        <Helmet title={pageTitle} />
        {children}
        <div className={styles.reportsContainer}>
          {reports && reports.map(r => <ReportCard
            report={r}
            key={r.id}
            currentUser={currentUser}
            overlay={getOverlay(r.id)} />)}
        </div>
        <div className={styles.loadWrapper}>
          {!loadOnScroll && nextPage !== 0 && nextPage !== -1 && <Button className={styles.loadMoreButton} onClick={this.loadOnScroll}>
            <Msg m={commonActions.loadMore} />
          </Button>}
          {loading && spinner}
          {loadOnScroll && !loading && nextPage !== -1 && <ScrollTrigger key={nextPage} paddingFactor={0.5} onScrollIntoView={this.loadNextPage}>{spinner}</ScrollTrigger>}
          {error && !loading && errorMessage}
          {reports && reports.size === 0 && !loading && noReportsMessage}
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { reports, topics } = state.rideReports
  const topic = topics.get(ownProps.endpoint)

  if (!topic) {
    return { currentUser: state.currentUser }
  }
  return {
    reports: topic.reportIds && topic.reportIds.map(id => reports.get(id)),
    loading: topic.loading,
    nextPage: topic.nextPage,
    error: topic.error,
    currentUser: state.currentUser,
    weeklyWinnerIds: state.rolloutContest.weeklyWinnerIds || [],
    wheelsetWinnerIds: state.rolloutContest.wheelsetWinnerIds || [],
    grandPrizeWinnerId: state.rolloutContest.grandPrizeWinnerId
  }
}

const mapDispatchToProps = {
  loadReportsForIndex: reportActions.loadReportsForIndex
}

export const ReportListContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(ReportList))
